import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {VetClinic} from "../../models/vet-clinic.model";
import {User} from "../../models/user.model";
import {Client} from "../../models/client.model";
import {forkJoin, Observable, of, Subscription} from "rxjs";
import {VetClinicData} from "../../models/vet-clinic-data.model";
import {VetineoVisitTypeCategory, VetineoVisitTypeSubCategory} from "../../models/vetineo-visit-type-category.model";
import {CommonUtils} from "../../utils/common";
import {FormBuilder, FormControl} from "@angular/forms";
import {AppStateService} from "../../providers/app-state.service";
import {ModalController, ToastController} from "@ionic/angular";
import {TranslateService} from "@ngx-translate/core";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {Router} from "@angular/router";
import {VetineoVisitTypeBundleService} from "../../providers/vetineo-visit-type-bundle.service";
import {ClientsService} from "../../providers/clients.service";
import {ItemFinderComponent} from "../item-finder/item-finder.component";
import {VetDoctorVetVisitType} from "../../models/vet-doctor-vet-visit-type.model";
import {SelectMultipleDoctorsComponent} from "../select-multiple-doctors/select-multiple-doctors.component";
import {VetineoVisitTypeBundle} from "../../models/vetineo-visit-type-bundle.model";
import {VetDoctorVetVisitTypeService} from "../../providers/vet-doctor-vet-visit-type.service";
import {
  EditVetineoVisitTypeBundleComponent
} from "../edit-vetineo-visit-type-bundle/edit-vetineo-visit-type-bundle.component";
import {
  EditVetDoctorVetVisitTypeComponent
} from "../edit-vet-doctor-vet-visit-type/edit-vet-doctor-vet-visit-type.component";
import {
  ConfigureVisitCategoriesForVetcodeModalComponent
} from "../configure-visit-categories-for-vetcode-modal/configure-visit-categories-for-vetcode-modal.component";
import {
  SelectVetDoctorVisitTypeTimeComponent
} from "../select-vet-doctor-visit-type-time/select-vet-doctor-visit-type-time.component";
import {
  VetDoctorVisitTypesInconsistenciesComponent
} from "../vet-doctor-visit-types-inconsistencies/vet-doctor-visit-types-inconsistencies.component";
import {catchError, finalize, map, switchMap, tap} from "rxjs/operators";

@Component({
  selector: 'app-vetineo-visit-type-bundle-configurator',
  templateUrl: './vetineo-visit-type-bundle-configurator.component.html',
  styleUrls: ['./vetineo-visit-type-bundle-configurator.component.scss'],
})
export class VetineoVisitTypeBundleConfiguratorComponent implements OnInit, OnDestroy {

  @Input() user: User;

  hasUnsavedChanges: boolean = false;
  selectOptions: any = {
    header: 'Wybierz lecznicę'
  };
  isAdmin: boolean;
  isGeneralAdmin: boolean;
  isBusy: boolean;
  isClientAdmin: boolean;
  isGeneralClientAdmin: boolean;
  clinics: VetClinic[] = [];
  clientSelected: Client;
  clientVetineoVisitTypeBundles: VetineoVisitTypeBundle[];
  clinicSelected: VetClinic;
  fullSelectedVetClinic: VetClinic;
  vetcodeId: any;
  private clinicSub: Subscription;
  vetClinicData: VetClinicData;
  subscriptions: Subscription = new Subscription();
  vetineoVisitTypeCategoriesForVetcode: VetineoVisitTypeCategory[];
  vetDoctorVetVisitTypeCounter: number;
  @Output() vetDoctorVetVisitTypeCounterEventEmitter: EventEmitter<number> = new EventEmitter<number>();
  hasVetClinicRole: boolean;
  isLegendPopoverOpen: any;
  legendPopoverEvent: any;
  currentLegendPopoverContent: string;
  private legendPopoverTimeout: any;
  private hoverIntentTimeout: any;
  legendMap = new Map(
    [['useBundleSettings', "Typ wizyty korzysta z domyślnych ustawień"],
      ["minutes", "Czas trwania wizyty"],
      ["prepaidRequired", "Typ wizyty wymaga przedpłaty"],
      ["infoPL", "Typ wizyty ma dedykowaną informację dla pacjenta"],
      ["minutesChangedByDoctorEdit", "Standardowy czas pracy lekarza został zmieniony. Kliknij w przycisk z zegarem i potwierdź lub zmień czas"],
      ["maxTermCancellation", "Maksymalny czas przed wizytą na dokonanie anulacji"],
      ["time", "Zmień czas wizyty"],
      ["multimediaEnabled", "Możliwość wysyłania plików multimedialnych"]]);
  private bundles: VetineoVisitTypeBundle[];
  protected clinicControl: FormControl;

  constructor(
    public commonUtils: CommonUtils,
    private formBuilder: FormBuilder,
    private appStateService: AppStateService,
    private toastController: ToastController,
    private modalController: ModalController,
    private translateService: TranslateService,
    private vetClinicService: VetClinicService,
    private router: Router,
    private vetineoVisitTypeBundleService: VetineoVisitTypeBundleService,
    private vetDoctorVetVisitTypeService: VetDoctorVetVisitTypeService,
    private clientsService: ClientsService,
  ) {
  }

  ngOnInit() {
    this.isAdmin = this.user.roles.split(';').filter(e => e === 'admin').length === 1;
    this.isGeneralClientAdmin = this.user.vClientId === null && this.user.vetcodeId === null && this.user.roles.split(';').filter(e => e === 'clients').length === 1;
    this.isGeneralAdmin = this.isAdmin && this.user.vClientId === null && this.user.vetcodeId === null;
    this.isClientAdmin = this.isAdmin && this.user.vClientId !== null && this.user.vetcodeId === null;
    this.hasVetClinicRole = this.user.roles.split(';').filter(e => e === 'vet-clinics').length === 1 && this.user.vClientId !== null;
    this.clinicControl = new FormControl(null);
    this.registerSubscription(
      this.clinicControl.valueChanges.subscribe(async newClinic => {
        await this.selectClinic(newClinic);
      })
    );

    if (this.user.vClientUUID) {
      this.appStateService.updateIsBusySubject(true);
      this.registerSubscription(this.clientsService.getClientByUUID(this.user.vClientUUID).subscribe(async client => {
        if (client) {
          this.clientSelected = client;
          // await this.getBundlesForClient();
          this.getClinicsForClient();

        }
        this.appStateService.updateIsBusySubject(false);
      }, error => {
        this.appStateService.updateIsBusySubject(false);
      }));
    }
    this.registerSubscription(this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    }));

  }

  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  async onSearchClients() {
    const modal = await this.modalController.create({
      component: ItemFinderComponent,
      componentProps: {
        title: 'Wyszukaj klienta',
        itemType: 'clients',
        nameToFind: this.clientSelected ? this.clientSelected.name : ''
      }
    });

    modal.onWillDismiss().then(async data => {
      if (data && data.data) {
        this.vetDoctorVetVisitTypeCounterEventEmitter.emit(null);
        this.clinicSelected = null;
        this.vetineoVisitTypeCategoriesForVetcode = null;
        this.clientSelected = data.data;
        // await this.getBundlesForClient();
        this.getClinicsForClient();
      }
    });

    return await modal.present();
  }

  private async loadFullClinicData(newClinic: VetClinic) {
    console.log("LOADING FULL CLINIC DATA");
    if (!newClinic) return;
    this.vetDoctorVetVisitTypeCounterEventEmitter.emit(null);
    this.clinicSelected = newClinic;
    this.clinicControl.setValue(this.clinicSelected, { emitEvent: false });
    try {
      this.appStateService.updateIsBusySubject(true);
      this.fullSelectedVetClinic = await this.vetClinicService.getSpecificVetClinic(this.clinicSelected.uuid).toPromise();
      this.vetcodeId = this.clinicSelected.vetcodeId;
      await this.getBundlesForClinic();
      this.getFullVisitTypeDataForVetcode();
    } catch(e) {
      this.commonUtils.presentAlertToast("Błąd podczas ładowania pełnych danych lecznicy");
      console.log(e);
    } finally {
      this.appStateService.updateIsBusySubject(false);
    }
  }

  async selectClinic(newClinic) {
    if (newClinic) {
      await this.loadFullClinicData(newClinic);
    }
  }

  async getClinicsForClient() {
    this.appStateService.updateIsBusySubject(true);
    this.clinicSub = this.vetClinicService.listClinicsForClient(this.clientSelected.uuid).subscribe(async e => {
      if (e) {
        this.clinics = e;
        let initialClinicToSelect = null;

        if (this.clinics.length === 1) {
          initialClinicToSelect = this.clinics[0];
        } else if (this.clinics.length > 1 && this.user.vetcodeId) {
          initialClinicToSelect = this.clinics.filter(e => e.vetcodeId == Number.parseInt(this.user.vetcodeId))[0];
        }
        if (initialClinicToSelect) {
          await this.loadFullClinicData(initialClinicToSelect);
        }

        this.appStateService.updateIsBusySubject(false);
      } else {
        this.appStateService.updateIsBusySubject(false);
        this.commonUtils.presentAlertToast('Nie znaleziono lecznic dla podanego klienta');
      }
    });
  }


  listToCommaString(list: string[]): string {
    return list.join(' | ');
  }

  exportToCsv(): void {
    const headers = ['nazwa typu', 'lekarz', 'czas trwania', 'info', 'czy można anulować', 'czas na anulowanie', 'czy wymaga powodu anulowania', 'gatunki', 'voucher', 'kwota vouchera', 'kategoria'];
    const rows: string[] = [];

    for (const category of this.vetineoVisitTypeCategoriesForVetcode) {
      for (const type of category?.subcategories) {
        if (type && type.bundle && type.bundle.vetDoctorVetVisitTypes) {
          for (const c of type?.bundle?.vetDoctorVetVisitTypes) {
            const allPetSpecies = c.allPetSpecies;
            let servedPetSpecies = this.listToCommaString(c.servedPetSpecies.map(e => e.name));
            if (allPetSpecies) {
              servedPetSpecies = 'wszystkie'
            }
            rows.push(
              `"${c.namePL}";"${c.vetDoctor?.name}";"${c.minutes}";"${c.infoPL ? c.infoPL : ''}"; "${c.termCanBeCancelled ? 'tak' : 'nie'}"; "${c.maxTermCancellation ? c.maxTermCancellation : ''}"; ${c.requireCancellationReason ? 'tak' : 'nie'}; ${servedPetSpecies}; "${c.prepaidRequired ? 'tak' : 'nie'}"; "${c.prepaidPrice ? c.prepaidPrice : '-'}";"${category.name}"`
            );
          }
        }

      }
    }

    const csvContent = `"${headers.join('";"')}"\n` + rows.join('\n');

    const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'});
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${this.clinicSelected.vetcodeId}.csv`;
    link.click();

    URL.revokeObjectURL(url);
  }


  public checkVetineoVisitTypesTimeChangeByDoctorEdit() {
    return this.clientVetineoVisitTypeBundles?.some(bundle => bundle?.vetDoctorVetVisitTypes?.filter(e => e.vetcodeId === this.vetcodeId)?.some(v => v.minutesChangedByDoctorEdit));
  }

  private async getBundlesForClient() {
    this.appStateService.updateIsBusySubject(true);
    try {
      this.clientVetineoVisitTypeBundles = await this.vetineoVisitTypeBundleService.getBundlesByClientUUID(this.clientSelected.uuid).toPromise();
      if (!this.clientVetineoVisitTypeBundles) {
        this.commonUtils.presentAlertToast("Nie znaleziono danych klienta");
      }
      this.appStateService.updateIsBusySubject(false);
    } catch (error) {
      console.log('getBundlesForClient')
      this.commonUtils.presentAlertToast("Wystąpił błąd przy pobieraniu danych klienta");
      this.appStateService.updateIsBusySubject(false);
    }
  }


  private async getBundlesForClinic() {
    this.appStateService.updateIsBusySubject(true);
    try {
      this.clientVetineoVisitTypeBundles = await this.vetineoVisitTypeBundleService.getBundlesByVetcodeId(this.clinicSelected.vetcodeId).toPromise();
      if (!this.clientVetineoVisitTypeBundles) {
        this.commonUtils.presentAlertToast("Nie znaleziono typów wizyt lecznicy");
      }
      this.appStateService.updateIsBusySubject(false);
    } catch (error) {
      console.log('getBundlesByVetcodeId')
      this.commonUtils.presentAlertToast("Wystąpił błąd przy pobieraniu typów wizyt lecznicy");
      this.appStateService.updateIsBusySubject(false);
    }
  }

  getFullVisitTypeDataForVetcode() {
    this.appStateService.updateIsBusySubject(true);

    this.registerSubscription(
      this.vetineoVisitTypeBundleService.getVetineoVisitTypeBundlesCategoriesForVetClinic(this.vetcodeId).pipe(

        tap(categories => this.vetineoVisitTypeCategoriesForVetcode = categories),

        switchMap(() => this.fetchCarePlanCategoryIfNeeded()),

        tap(carePlanCategory => this.addCarePlanCategory(carePlanCategory)),

        switchMap(() => {
          const requests$ = this.buildVetDoctorVisitTypeRequests();
          return requests$.length > 0 ? forkJoin(requests$) : of([]);
        }),

        tap(results => {
          this.assignVetDoctorVisitTypesToBundles(results);
        }),

        finalize(() => this.appStateService.updateIsBusySubject(false))

      ).subscribe({
        error: err => {
          console.error('Error during fetching visit types data:', err);
          this.commonUtils.presentAlertToast("Wystąpił błąd przy pobieraniu kategorii lecznicy");
        }
      })
    );
  }

  private fetchCarePlanCategoryIfNeeded(): Observable<any> {
    if (this.clinicSelected?.carePlanEnabled && this.vetineoVisitTypeCategoriesForVetcode?.length > 0) {
      return this.vetineoVisitTypeBundleService.getNewestVetineoVisitTypeBundlesCarePlanCategory();
    }
    return of(null);
  }

  private addCarePlanCategory(carePlanCategory: any): void {
    if (carePlanCategory?.code) {
      carePlanCategory.orderIdx = 0;
      this.vetineoVisitTypeCategoriesForVetcode.push(carePlanCategory);
    }
    this.vetineoVisitTypeCategoriesForVetcode.sort((a, b) => a.orderIdx - b.orderIdx);
  }

  private buildVetDoctorVisitTypeRequests(): Observable<any>[] {
    this.bundles = [];

    for (const cat of this.vetineoVisitTypeCategoriesForVetcode) {
      for (const subCat of cat.subcategories) {
        const bundle = this.clientVetineoVisitTypeBundles?.find(b =>
          b.vetineoVisitTypeCategoryCode === cat.code && b.subCategoryCode === subCat.code
        );
        if (bundle) this.bundles.push(bundle);
      }
    }

    return this.bundles.map(bundle => {
      const uuid = bundle.vetineoVisitTypeBundleUUID || bundle.uuid;
      return this.vetDoctorVetVisitTypeService.getByBundleUUID(uuid, this.vetcodeId).pipe(
        map(visitTypes => ({ bundle, visitTypes })),
        catchError(error => {
          console.error(`Error for bundle ${uuid}`, error);
          return of({ bundle, visitTypes: [] });
        })
      );
    });
  }

  private assignVetDoctorVisitTypesToBundles(results: {bundle: VetineoVisitTypeBundle, visitTypes: VetDoctorVetVisitType[]}[]): void {
    for (const result of results) {
      const { bundle, visitTypes } = result;
      bundle.vetDoctorVetVisitTypes = visitTypes;

      const category = this.vetineoVisitTypeCategoriesForVetcode.find(cat => cat.code === bundle.vetineoVisitTypeCategoryCode);
      if (category) {
        const subCat = category.subcategories.find(sub => sub.code === bundle.subCategoryCode);
        if (subCat) {
          subCat.bundle = bundle;
        }
      }
    }
  }

  private async matchSubcategoriesWithBundles() {
    this.vetDoctorVetVisitTypeCounter = 0;
    for (const cat of this.vetineoVisitTypeCategoriesForVetcode) {
      for (const subCat of cat.subcategories) {
        const bundle = this.clientVetineoVisitTypeBundles?.find(bundle => {
          return bundle.vetineoVisitTypeCategoryCode === cat.code && bundle.subCategoryCode === subCat.code;
        });
        if (bundle) {
          try {
            this.appStateService.updateIsBusySubject(true);
            let vetineoVisitTypeBundleUUID = bundle.vetineoVisitTypeBundleUUID ? bundle.vetineoVisitTypeBundleUUID : bundle.uuid;
            bundle.vetDoctorVetVisitTypes = await this.vetDoctorVetVisitTypeService.getByBundleUUID(vetineoVisitTypeBundleUUID, this.vetcodeId).toPromise();
            if (bundle.vetDoctorVetVisitTypes && bundle.vetDoctorVetVisitTypes.length > 0) {
              this.vetDoctorVetVisitTypeCounter += bundle.vetDoctorVetVisitTypes.length;
            }
            this.appStateService.updateIsBusySubject(false);
          } catch (e) {
            console.log(e);
            this.appStateService.updateIsBusySubject(false);
          }

        }
        subCat.bundle = bundle;
      }
    }
    this.vetDoctorVetVisitTypeCounterEventEmitter.emit(this.vetDoctorVetVisitTypeCounter);
  }

  async onOpenSelectDoctorsModal($event: any, bundle: VetineoVisitTypeBundle) {
    $event.stopPropagation();
    try {
      this.appStateService.updateIsBusySubject(true);
      this.appStateService.updateIsBusySubject(false);

      const modal = await this.modalController.create({
        component: SelectMultipleDoctorsComponent,
        componentProps: {
          vetClinic: this.fullSelectedVetClinic,
          doctors: this.fullSelectedVetClinic.team,
          user: this.user,
          vetineoVisitTypeBundle: bundle,
          vetDoctorVisitTypes: bundle.vetDoctorVetVisitTypes,
        },
        cssClass: 'longer-modal'
      });

      modal.onDidDismiss<VetDoctorVetVisitType[]>().then((dismissData) => {
        if (dismissData && dismissData.data !== undefined && dismissData.data) {
          this.commonUtils.presentInfoToast('Lekarze zostali dodani do typu wizyty');
          if (!bundle.vetDoctorVetVisitTypes) {
            bundle.vetDoctorVetVisitTypes = dismissData.data;

          } else {
            bundle.vetDoctorVetVisitTypes.push(...dismissData.data);
          }
          this.vetDoctorVetVisitTypeCounter += dismissData.data.length;
          this.vetDoctorVetVisitTypeCounterEventEmitter.emit(this.vetDoctorVetVisitTypeCounter);
        }
      });
      await modal.present();

    } catch (e) {
      this.commonUtils.presentAlertToast("Wystąpił błąd przy pobieraniu danych lecznicy");
      this.appStateService.updateIsBusySubject(false);
    }
  }

  async onOpenConfigureModal($event: any, innerCategory: VetineoVisitTypeSubCategory, category: VetineoVisitTypeCategory, action: 'ADD' | 'EDIT') {
    $event.stopPropagation();
    const modal = await this.modalController.create({
      component: EditVetineoVisitTypeBundleComponent,
      backdropDismiss: false,
      componentProps: {
        user: this.user,
        action: action,
        selectedCategory: category,
        selectedSubCategory: innerCategory,
        clientSelected: this.clientSelected,
        vetcodeId: this.vetcodeId,
        vetineoVisitTypeBundle: innerCategory?.bundle?.uuid ? {...innerCategory.bundle} : null
      },
      cssClass: 'vetineo-visit-type-bundle-config-modal'
    });

    modal.onDidDismiss<VetineoVisitTypeBundle>().then((dismissData) => {
      if (dismissData && dismissData.data !== undefined && dismissData.data && dismissData.role) {
        innerCategory.bundle = dismissData.data;
        if (dismissData.role === 'ADD') {
          this.commonUtils.presentInfoToast("Konfiguracja typu wizyty zapisana pomyślnie");
        }
        if (dismissData.role === 'EDIT') {
          this.commonUtils.presentInfoToast("Nowa konfiguracja typu wizyty zapisana pomyślnie");
        }
      }
    });
    await modal.present();
  }

  async onOpenConfigureVetDoctorVisitTypeModal($event: any, vetDoctorVetVisitType: VetDoctorVetVisitType, bundle: VetineoVisitTypeBundle) {
    $event.stopPropagation();
    const modal = await this.modalController.create({
      component: EditVetDoctorVetVisitTypeComponent,
      backdropDismiss: false,
      componentProps: {
        user: this.user,
        action: 'EDIT',
        vetDoctorVetVisitType: {...vetDoctorVetVisitType},
        clientSelected: this.clientSelected,
        doctor: {...vetDoctorVetVisitType.vetDoctor},
        vetClinic: this.clinicSelected,
        vetineoVisitTypeBundle: bundle
      },
      cssClass: 'vet-doctor-visit-type-bundle-config-modal'
    });

    modal.onDidDismiss<VetDoctorVetVisitType>().then((dismissData) => {
      if (dismissData && dismissData.data !== undefined && dismissData.data && dismissData.role) {
        if (dismissData.role === 'EDIT') {
          dismissData.data.vetineoVisitTypeBundle = bundle;
          bundle.vetDoctorVetVisitTypes
            .splice(bundle.vetDoctorVetVisitTypes
              .findIndex(visitType => visitType.uuid === dismissData.data.uuid), 1, {...dismissData.data});
          this.commonUtils.presentInfoToast("Nowa konfiguracja typu wizyty dla pracownika zapisana pomyślnie");
        }
      }
    });
    await modal.present();
  }


  registerSubscription(sub: Subscription) {
    if (sub) {
      this.subscriptions.add(sub);
    }
  }

  getSelectedText() {
    if (this.clinicSelected && this.clinics && this.clinics.length > 1) {
      const sameNameClinicExists = this.clinics.some(c => this.clinicSelected.clinicName === c.clinicName);
      if (sameNameClinicExists) {
        return this.commonUtils.getClinicNameWithAddress(this.clinicSelected);
      }
    }
    if (this.clinicSelected) {
      return this.clinicSelected.clinicName;
    } else {
      return '';
    }
  }




  getConfigureBundleButtonName(innerCategory: VetineoVisitTypeSubCategory) {
    return innerCategory.bundle ? "Ustawienia domyślne" : "Konfiguruj";
  }

  getVetDoctorVetVisitTypes(bundle: VetineoVisitTypeBundle) {
    if (bundle) {
      return bundle.vetDoctorVetVisitTypes.filter(vetDoctorVetVisitType => this.vetcodeId == vetDoctorVetVisitType.vetcodeId).sort((a, b) => {
        return new Date(b.created).getTime() - new Date(a.created).getTime();
      });
    }
    return null;
  }

  protected onDeleteVisitType(vetDoctorVetVisitTypeUUID: string, bundle: VetineoVisitTypeBundle) {
    this.appStateService.updateIsBusySubject(true);
    this.registerSubscription(this.vetDoctorVetVisitTypeService.checkForReservationsForVetDoctorVisitType(vetDoctorVetVisitTypeUUID).subscribe(reservationCheck => {
      if (reservationCheck) {
        this.appStateService.updateIsBusySubject(false);
        if (reservationCheck.existAny) {
          let text = 'Na pewno chcesz usunąć typ wizyty dla tego lekarza?';
          let reservationName = this.getReservationInForm(reservationCheck.reservationCounter);
          let remindersName = this.getReminderInForm(reservationCheck.nextVisitReminderCounter);
          if (reservationCheck.reservationCounter > 0 && reservationCheck.nextVisitReminderCounter > 0) {
            text = `Aktualnie dla tego typu wizyty zaplanowano ${reservationCheck.reservationCounter} ${reservationName} i ${reservationCheck.nextVisitReminderCounter} ${remindersName} na wizytę.`
          }
          if (reservationCheck.reservationCounter > 0 && reservationCheck.nextVisitReminderCounter === 0) {
            text = `Aktualnie dla tego typu wizyty zaplanowano ${reservationCheck.reservationCounter} ${reservationName}.`
          }
          if (reservationCheck.reservationCounter === 0 && reservationCheck.nextVisitReminderCounter > 0) {
            text = `Aktualnie dla tego typu wizyty zaplanowano ${reservationCheck.nextVisitReminderCounter} ${remindersName}.`;
          }
          text = text + ' Na pewno chcesz usunąć ten typ wizyty?';
          this.commonUtils.presentYesNoActionSheet(text, 'Tak', 'Nie', 'trash', 'close', () => {
            this.handleDelete(vetDoctorVetVisitTypeUUID, bundle);
          }, () => {
          });
        } else {
          this.handleDelete(vetDoctorVetVisitTypeUUID, bundle);
        }
      } else {
        this.appStateService.updateIsBusySubject(false);
        this.commonUtils.presentAlertToast('Wystąpił błąd podczas usuwania typu wizyty');
      }
    }, error => {
      this.appStateService.updateIsBusySubject(false);
      this.commonUtils.presentAlertToast('Wystąpił błąd podczas usuwania typu wizyty');
    }));
  }

  getReservationInForm(counter: number): string {
    const modulo10 = counter % 10;
    const modulo100 = counter % 100;

    if (counter === 1) {
      return 'rezerwacja';
    }

    if (
      modulo10 >= 2 &&
      modulo10 <= 4 &&
      !(modulo100 >= 12 && modulo100 <= 14)
    ) {
      return 'rezerwacje';
    }

    return 'rezerwacji';
  }

  getReminderInForm(counter: number): string {
    const modulo10 = counter % 10;
    const modulo100 = counter % 100;

    if (counter === 1) {
      return 'zaproszenie';
    }

    if (
      modulo10 >= 2 &&
      modulo10 <= 4 &&
      !(modulo100 >= 12 && modulo100 <= 14)
    ) {
      return 'zaproszenia';
    }

    return 'zaproszeń';
  }

  handleDelete(vetDoctorVetVisitTypeUUID: string, bundle: VetineoVisitTypeBundle) {
    this.appStateService.updateIsBusySubject(true);
    this.registerSubscription(this.vetDoctorVetVisitTypeService.deleteVisitType(vetDoctorVetVisitTypeUUID).subscribe(result => {
      this.appStateService.updateIsBusySubject(false);
      if (result) {
        this.commonUtils.presentInfoToast('Usunięcie zakończone powodzeniem');
        bundle.vetDoctorVetVisitTypes = bundle.vetDoctorVetVisitTypes.filter(e => e.uuid != vetDoctorVetVisitTypeUUID);
        this.vetDoctorVetVisitTypeCounter--;
        this.vetDoctorVetVisitTypeCounterEventEmitter.emit(this.vetDoctorVetVisitTypeCounter);
      } else {
        this.commonUtils.presentAlertToast('Wystąpił błąd podczas usuwania typu wizyty');
      }
    }, error => {
      this.appStateService.updateIsBusySubject(false);
      this.commonUtils.presentAlertToast('Wystąpił błąd podczas usuwania typu wizyty');
    }));
  }


  async openConfigureCategoriesForVetcodeModal(vetClinicUuid: string) {
    const modal = await this.modalController.create({
      component: ConfigureVisitCategoriesForVetcodeModalComponent,
      componentProps: {
        vetClinicUuid,
        user: this.user
      },
      cssClass: 'longer-modal'
    });

    modal.onDidDismiss<any>().then((dismissData) => {
      if (dismissData && dismissData.role === 'success') {
        this.getFullVisitTypeDataForVetcode();
      }
    });

    return await modal.present();
  }

  checkIfVetClinicUserWithOneVetClinic() {
    return (this.hasVetClinicRole || this.isAdmin) && this.clinics && this.clinics.length === 1;
  }


  async onEditVetDoctorVetVisitTypeTime($event: any, vetDoctorVetVisitType: VetDoctorVetVisitType, bundle: VetineoVisitTypeBundle) {
    vetDoctorVetVisitType.vClientId = this.clientSelected?.id;
    $event.stopPropagation();

    console.log('before modal', vetDoctorVetVisitType)
    const modal = await this.modalController.create({
      component: SelectVetDoctorVisitTypeTimeComponent,
      componentProps: {
        action: 'EDIT',
        vetDoctorVetVisitType: {...vetDoctorVetVisitType},
        minuteSelected: vetDoctorVetVisitType.minutes,
        vetDoctor: vetDoctorVetVisitType.vetDoctor,
        user: this.user
      },
      cssClass: 'longer-modal'

    });

    modal.onDidDismiss<VetDoctorVetVisitType>().then((dismissData) => {
      if (dismissData && dismissData.data !== undefined && dismissData.data) {
        bundle.vetDoctorVetVisitTypes
          .splice(bundle.vetDoctorVetVisitTypes
            .findIndex(visitType => visitType.uuid === dismissData.data.uuid), 1, {...dismissData.data});
        dismissData.data.vetineoVisitTypeBundle = bundle;

        this.commonUtils.presentInfoToast("Nowa konfiguracja typu wizyty dla pracownika zapisana pomyślnie");
      }

    });

    return await modal.present();
  }


  async onOverrideBundles(customSettings) {
    this.commonUtils.presentYesNoActionSheet('Czy na pewno chcesz skopiować ustawienia typów wizyt?', 'Tak', 'Nie', 'checkmark-outline', 'close', async () => {
      this.appStateService.updateIsBusySubject(true);
      this.registerSubscription(this.vetineoVisitTypeBundleService.overrideBundles(this.clinicSelected.vetcodeId, customSettings).subscribe(
        clientVetineoVisitTypeBundles => {
          this.clientVetineoVisitTypeBundles = clientVetineoVisitTypeBundles;
          if (!this.clientVetineoVisitTypeBundles) {
            this.commonUtils.presentAlertToast("Wystąpił problem podczas tworzenia kopii typów wizyt");
          }
          this.matchSubcategoriesWithBundles();
          this.clinicSelected.bundlesOverride = new Date();
          this.appStateService.updateIsBusySubject(false);
        }, error => {
          this.commonUtils.presentAlertToast("Wystąpił problem podczas tworzenia kopii typów wizyt");
          this.appStateService.updateIsBusySubject(false);
        }
      ));
    }, () => {
    });
  }

  async onCreateClearCustomSettings() {
    this.commonUtils.presentYesNoActionSheet('Czy na pewno chcesz utworzyć kopie typów wizyt zgodne z aktualnymi ustawieniami?', 'Tak', 'Nie', 'checkmark-outline', 'close', async () => {
      this.appStateService.updateIsBusySubject(true);
      this.registerSubscription(this.vetineoVisitTypeBundleService.createClearCustomBundleSettings(this.clinicSelected.vetcodeId).subscribe(
        clientVetineoVisitTypeBundles => {
          this.clientVetineoVisitTypeBundles = clientVetineoVisitTypeBundles;
          if (!this.clientVetineoVisitTypeBundles) {
            this.commonUtils.presentAlertToast("Wystąpił problem podczas tworzenia kopii typów wizyt");
          }
          this.matchSubcategoriesWithBundles();
          this.clinicSelected.bundlesOverride = new Date();
          this.appStateService.updateIsBusySubject(false);
        }, error => {
          this.commonUtils.presentAlertToast("Wystąpił problem podczas tworzenia kopii typów wizyt");
          this.appStateService.updateIsBusySubject(false);
        }
      ));
    }, () => {
    });
  }

  onOverrideBundlesForOneClinicClient() {
    this.commonUtils.presentYesNoActionSheet('Czy na pewno chcesz przywrócić typy wizyt lekarzy do ustawień głównych?', 'Tak', 'Nie', 'checkmark-outline', 'close', async () => {
      this.appStateService.updateIsBusySubject(true);
      this.registerSubscription(this.vetineoVisitTypeBundleService.overrideBundlesForOneClinicClient(this.clinicSelected.vetcodeId).subscribe(clientVetineoVisitTypeBundles => {
          this.clientVetineoVisitTypeBundles = clientVetineoVisitTypeBundles;
          if (!this.clientVetineoVisitTypeBundles) {
            this.commonUtils.presentAlertToast("Wystąpił problem podczas przywracania ustawien głównych typów wizyt lekarza");
          }

          this.matchSubcategoriesWithBundles();
          this.clinicSelected.bundlesOverride = new Date();
          this.appStateService.updateIsBusySubject(false);
        }, error => {
          this.appStateService.updateIsBusySubject(false);

        }
      ));

    }, () => {
    });
  }

  async openModalForBundleCustomSettings() {
    let visitTypeOptions = [];

    this.vetineoVisitTypeCategoriesForVetcode?.forEach(category => {
      category?.subcategories?.forEach(subCategory => {
        if (!subCategory.bundle) {
          return;
        }

        const doctorTypes = subCategory.bundle.vetDoctorVetVisitTypes;

        const descriptionMap = new Map<string, string[]>();
        const cancellationMap = new Map<number, string[]>();
        const cancellationReasonMap = new Map<boolean, string[]>();

        doctorTypes.forEach(dt => {
          const doctorName = this.getDoctorName(dt);

          const infoPl = dt.infoPL ? dt.infoPL.length > 0 ? dt.infoPL : '-' : '-';

          if (!descriptionMap.has(infoPl)) {
            descriptionMap.set(infoPl, []);
          }
          descriptionMap.get(infoPl)!.push(doctorName);

          let termCanBeCancelled = dt.termCanBeCancelled;
          let requireCancellationReason = false;
          let maxTermCancellation = null;
          if (termCanBeCancelled) {
            maxTermCancellation = dt.maxTermCancellation;
            requireCancellationReason = dt.requireCancellationReason ? dt.requireCancellationReason : false;
          }

          if (!cancellationMap.has(maxTermCancellation)) {
            cancellationMap.set(maxTermCancellation, []);
          }
          cancellationMap.get(maxTermCancellation)!.push(doctorName);


          if (!cancellationReasonMap.has(requireCancellationReason)) {
            cancellationReasonMap.set(requireCancellationReason, []);
          }
          cancellationReasonMap.get(requireCancellationReason)!.push(doctorName);
        });

        const descriptions = Array.from(descriptionMap.entries()).map(
          ([value, doctors]) => ({
            value,
            doctors
          })
        );

        const cancellationTimes = Array.from(cancellationMap.entries()).map(
          ([value, doctors]) => ({
            value,
            doctors
          })
        );

        const cancellationReasons = Array.from(cancellationReasonMap.entries()).map(
          ([value, doctors]) => ({
            value,
            doctors
          })
        );


        visitTypeOptions.push({
          visitTypeName: subCategory.name,
          uuid: subCategory.bundle.uuid,
          descriptions,
          cancellationTimes,
          cancellationReasons
        });
      });
    });

    if (visitTypeOptions && visitTypeOptions.length > 0) {
      const modal = await this.modalController.create({
        component: VetDoctorVisitTypesInconsistenciesComponent,
        backdropDismiss: false,
        componentProps: {
          visitTypeOptions: visitTypeOptions,
          vetineoVisitTypeCategoriesForVetcode: this.vetineoVisitTypeCategoriesForVetcode,
          vetClinic: this.clinicSelected
        }
      });

      modal.onDidDismiss().then((dismissData) => {
        if (dismissData && dismissData.data !== undefined && dismissData.data) {
          const customSettings = Object.entries(dismissData.data).map(([uuid, value]) => ({
            uuid,
            cancellationTime: (value as any)?.cancellationTime ? (value as any)?.cancellationTime : null,
            description: (value as any)?.description ? (value as any)?.description : null,
            requireCancellationReason: (value as any)?.requireCancellationReason ? (value as any)?.requireCancellationReason : false
          }));

          this.onOverrideBundles(customSettings)
        }
      });
      await modal.present();
    } else {

    }
  }

  private getDoctorName(dt: VetDoctorVetVisitType) {
    return dt.vetDoctor.name;
  }

  createClearCopy() {
    this.commonUtils.presentYesNoActionSheet('Czy na pewno chcesz skopiować ustawienia typów wizyt?', 'Tak', 'Nie', 'checkmark-outline', 'close', async () => {
      this.appStateService.updateIsBusySubject(true);
      this.registerSubscription(this.vetineoVisitTypeBundleService.createClearCustomBundleSettings(this.clinicSelected.vetcodeId).subscribe(
        clientVetineoVisitTypeBundles => {
          this.clientVetineoVisitTypeBundles = clientVetineoVisitTypeBundles;
          if (!this.clientVetineoVisitTypeBundles) {
            this.commonUtils.presentAlertToast("Wystąpił problem podczas tworzenia kopii typów wizyt");
          }
          this.matchSubcategoriesWithBundles();
          this.clinicSelected.bundlesOverride = new Date();
          this.appStateService.updateIsBusySubject(false);
        }, error => {
          this.commonUtils.presentAlertToast("Wystąpił problem podczas tworzenia kopii typów wizyt");
          this.appStateService.updateIsBusySubject(false);
        }
      ));
    }, () => {
    });
  }

  canConfigure() {
    return this.clinics?.length == 1 || this.clinicSelected?.useBundleCustomOverride || this.isGeneralClientAdmin || this.isGeneralAdmin;
  }

  isFullTeamAssigned(currentDoctorsCount: number): boolean {
    const teamSize = this.fullSelectedVetClinic?.team?.length;
    return currentDoctorsCount >= teamSize;
  }

  openLegendPopover($event: MouseEvent, iconType: string) {
    $event.preventDefault();
    $event.stopPropagation();

    if (this.legendPopoverTimeout) {
      clearTimeout(this.legendPopoverTimeout);
    }
    if (this.hoverIntentTimeout) {
      clearTimeout(this.hoverIntentTimeout);
    }

    this.hoverIntentTimeout = setTimeout(() => {

      const target = $event.target as HTMLElement;
      if (target && typeof target.focus === 'function') {
        target.focus({ preventScroll: true });
      }
      this.currentLegendPopoverContent = this.legendMap.get(iconType);
      if (this.currentLegendPopoverContent) {
        this.legendPopoverEvent = $event;
        this.isLegendPopoverOpen = true;
      }

    }, 75);
  }

  closeLegendPopover() {

    if (this.hoverIntentTimeout) {
      clearTimeout(this.hoverIntentTimeout);
    }
    this.legendPopoverTimeout = setTimeout(() => {
      this.isLegendPopoverOpen = false;

      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    }, 50);
  }
}
